<h2>Frequently asked questions</h2>

<details>
  <summary>Where can I buy the Icy Penguin NFT?</summary>
  <p>
    The Icy Penguin NFT, can be bought on rarible and will soon be available on
    opensea.io.
  </p>
</details>

<details>
  <summary>Where can I buy this NFT?</summary>
  <p>
    The Icy Penguin NFT, can be bought on rarible and will soon be available on
    opensea.io.
  </p>
</details>

<details>
  <summary>Where can I buy this NFT?</summary>
  <p>
    The Icy Penguin NFT, can be bought on rarible and will soon be available on
    opensea.io.
  </p>
</details>

<details>
  <summary>Where can I buy this NFT?</summary>
  <p>
    The Icy Penguin NFT, can be bought on rarible and will soon be available on
    opensea.io.
  </p>
</details>

<details>
  <summary>Where can I buy this NFT?</summary>
  <p>
    The Icy Penguin NFT, can be bought on rarible and will soon be available on
    opensea.io.
  </p>
</details>

<style>
  h2 {
    font-size: 1.5rem;
    margin-top: 2rem;
  }

  details {
    cursor: pointer;
    margin-top: 2rem;
    text-align: left;
    border: 1px solid #bcc5d5;
    border-radius: 0.5em;
    padding: 2em 3em;
  }

  details > summary {
    font-size: 1.2rem;
    font-weight: bold;
  }

  details > p {
    padding-top: 1em;
  }

  details[open] p {
    animation: sweep 0.5s ease-in-out;
  }

  summary::marker {
    color: #452b52;
  }

  @keyframes sweep {
    from {
      opacity: 0;
      margin-top: -10px;
    }
    to {
      opacity: 1;
      margin-top: 0;
    }
  }
</style>
